<section class="flex w-full h-full p-20 md:p-30 bg-top bg-no-repeat bg-cover bg-fixed"
  style="background: url(./assets/images/wave-bg-mint-dark2.svg)">
  <div class="flex flex-col w-full mx-auto min-h">
    <div class="flex flex-col flex-grow card">
      @if (this.isLoading || this.isLoading_schwab || this.isLoading_orion) {
      <section class="flex w-full h-full">
        <div class="flex-grow w-full loader-wrap">
          <div class="loader-sm is-mint"></div>
        </div>
      </section>
      }
      @else {
      <!-- <div class="w-full flex justify-end">    
        <button [routerLink]="['/portal/accounts']" mat-button class="m-10 ml-auto icon-button is-mint is-inverted" [disabled]="this.isLoading || this.isLoading_schwab || this.isLoading_orion" type="button">
          <i class="material-icons">close</i>
        </button>
      </div> -->
      <div class="flex items-start justify-between p-15 border-b border-solid md:p-25 border-gray-lighter">
        <div class="flex flex-col">
          <!-- <h2 class="flex items-center mr-70 text-lg font-bold"><span>{{ this.account?.custodian + ' - ' +
                this.account?.accountNumber }}</span></h2>
            <h2 class="flex items-center mr-70 text-m font-semibold"><span>{{ this.account?.investmentAccountModel
                }}</span></h2>
            <h2 class="flex items-center mr-70 text-m font-semibold"><span>{{ this.account?.investmentAccountType
                }}</span></h2> -->
          <h2 class="flex items-center mr-70 text-lg font-bold text-gray-darker"><span>{{ this.account?.title }}</span>
          </h2>
          <h2 class="flex items-center mr-70 text-m font-semibold text-gray-dark"><span>{{ this.account?.title2}}</span>
          </h2>
          <h2 class="flex items-center mr-70 text-m font-semibold text-gray-dark"><span>{{ this.account?.title3
              }}</span></h2>
        </div>
        <div class="flex flex-row gap-x-20 align-top">
          <ng-container>
            <button mat-button class="px-10 button is-mint is-inverted" (click)="openAccountUpdateModal()">
              <span class="flex items-center justify-center ">
                <!-- <span class="mr-5 material-icons mi-18">add</span> -->
                <span>Submit New Request</span>
              </span>
            </button>
            <button mat-button class="px-10 button is-mint is-inverted" (click)="getAccountData()">
              <span class="flex items-center justify-center ">
                <span class="mr-5 material-icons mi-18">refresh</span>
                <span>Refresh</span>
              </span>
            </button>
            <button [routerLink]="['/portal/accounts']" mat-button class="mb-10 ml-10 button icon-button is-mint is-inverted" [disabled]="this.isLoading || this.isLoading_schwab || this.isLoading_orion" type="button"
            matTooltip="Back to accounts">
              <i class="material-icons">close</i>
            </button>
          </ng-container>
        </div>
      </div>
      <div>
        <mat-tab-group class="is-mint-tabs" mat-stretch-tabs="false" mat-align-tabs="start">
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="ml-2">Overview</span>
            </ng-template>
            <div
              class="flex flex-row w-full h-640 overflow-y-scroll border-t border-solid border-gray-lighter bg-gradient-to-t from-gray-lighter to-gray-lightest text-sm">
              <div class="grid gap-10 p-20 overflow-auto grid-cols-3 w-full">
                <div class="flex flex-col flex-grow p-20 bg-no-repeat bg-cover card bg-wave-sm">
                  <div class="flex flex-row pb-5">
                    <div class="font-bold w-200 text-base">
                      Account Information
                    </div>
                  </div>
                  <!-- <div class="flex flex-row justify-between w-full gap-x-10 pb-5">
                      <span>Advisor</span>
                      <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                      <span class="font-bold text-gray-dark">
                        @for (a of this.account?.advisors; track a; let last = $last) {
                        {{ a.firstName + ' ' + a.lastName}}
                        @if (!last){ , }
                        }
                      </span>
                    </div> -->
                  <div class="flex flex-row justify-between w-full gap-x-10 pb-5">
                    <span>Title</span>
                    <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                    <span class="font-bold text-gray-dark">
                      {{ this.account?.title }}
                    </span>
                  </div>
                  <div class="flex flex-row justify-between w-full gap-x-10 pb-5">
                    <span>Account Number</span>
                    <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                    <span class="font-bold text-gray-dark">{{this.account?.accountNumber}}</span>
                  </div>
                  <div class="flex flex-row justify-between w-full gap-x-10 pb-5">
                    <span>Account Type</span>
                    <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                    <span class="font-bold text-gray-dark uppercase">
                      {{this.account?.investmentAccountType}}
                      <!-- {{ this.account?.title3 === null ? this.account?.title2 : this.account?.title3 }} -->
                    </span>
                  </div>
                  @if (this.account?.openedOn !== null) {
                  <div class="flex flex-row justify-between w-full gap-x-10 pb-5">
                    <span>Established On</span>
                    <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                    <span class="font-bold text-gray-dark">{{this.account?.openedOn | date: 'shortDate'}}</span>
                  </div>
                  }
                  @if (this.schwabAccountIsLoaded) {
                  @if (this.accountBeneficiaries && this.accountBeneficiaries.length > 0) {
                  <div class="flex flex-row pb-5 pt-10">
                    <div class="font-bold w-200 text-base">
                      Account Beneficiaries
                    </div>
                  </div>

                  @for (holder of this.accountBeneficiaries; track holder;){
                  <div class="flex flex-row justify-between w-full gap-x-10 pb-5">
                    <span>{{holder.name}}</span>
                    <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                    <span class="font-bold text-gray-dark">{{holder.role === 'CONTB' ? 'CONTINGENT' :
                      holder.role === 'BENE' ? 'PRIMARY' : ''}}
                      {{holder.beneficiaryAssetPercentage}}</span>
                  </div>
                  }
                  }

                  @if (this.accountHolders && this.accountHolders.length > 0) {
                  <div class="flex flex-row pb-5 pt-10">
                    <div class="font-bold w-200 text-base">
                      Account Holders
                    </div>
                  </div>

                  @for (holder of this.accountHolders; track holder;){
                  <div class="flex flex-row justify-between w-full gap-x-10 pb-5">
                    <span>{{holder.name}}</span>
                    <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                    <!-- <span class="font-bold text-gray-dark">{{holder.role}}</span> -->
                    <span class="font-bold text-gray-dark">{{holder.role === 'VIEWO' ? 'VIEW ONLY' : holder.role ===
                      'GRNTR' ? 'GRANTOR' :
                      holder.role === 'TTEE' ? 'TRUSTEE' : holder.role}}</span>
                  </div>
                  }
                  }

                  @if (this.accountMoneyManagers && this.accountMoneyManagers.length > 0) {
                  <div class="flex flex-row pb-5 pt-10">
                    <div class="font-bold w-200 text-base">
                      Money Managers
                    </div>
                  </div>

                  @for (holder of this.accountMoneyManagers; track holder;){
                  <div class="flex flex-row justify-between w-full gap-x-10 pb-5">
                    <span>{{holder.name}}</span>
                    <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                    <!-- <span class="font-bold text-gray-dark">{{holder.role}}</span> -->
                    <span class="font-bold text-gray-dark">{{holder.role}}</span>
                  </div>
                  }
                  }
                  }
                </div>
                @if (this.schwabAccountIsLoaded) {
                <div class="flex flex-col flex-grow p-20 bg-no-repeat bg-cover card bg-wave-sm">
                  <div class="flex flex-row">
                    <div class="font-bold w-200 text-base">
                      Account Totals <span class="text-xl text-mint-darker">*</span>
                    </div>
                  </div>
                  <div class="flex flex-row justify-between w-full gap-x-10 pb-5">
                    <span>Account Value</span>
                    <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                    <span class="font-bold text-gray-dark">{{this.schwabAccountModel?.balances?.accountNetWorth
                      | currency}}</span>
                  </div>
                  <!-- <div class="flex flex-row justify-between w-full gap-x-10 pb-5">
                      <span>Value Day Change</span>
                      <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                      <span
                        class="font-bold text-gray-dark">{{this.schwabAccountModel?.positions?.totalPositions?.totalDayChange
                        | currency}}
                        ({{this.schwabAccountModel?.positions?.totalPositions?.totalDayChangePercentage?.toFixed(2)}}%)</span>
                    </div>                                                         -->
                  <!-- <div class="flex flex-row justify-between  w-full gap-x-10 pt-10 pb-5 font-bold text-base">
                    <span>Cash and Cash Investments<span class="text-xl text-mint-darker pl-4">*</span></span>
                    <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                    <span class="font-bold text-gray-dark">{{this.schwabAccountModel?.balances?.cashAndCashInvestments |
                      currency}}</span>
                  </div>
                  <div class="flex flex-row justify-between w-full gap-x-10 pb-5">
                    <span>Cash</span>
                    <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                    <span class="font-bold text-gray-dark">{{this.schwabAccountModel?.balances?.cash
                      | currency}}</span>
                  </div>
                  <div class="flex flex-row justify-between w-full gap-x-10 pb-5">
                    <span>{{this.schwabAccountModel?.balances?.bankSweepName}}</span>
                    <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                    <span class="font-bold text-gray-dark">{{this.schwabAccountModel?.balances?.bankSweep|
                      currency}}</span>
                  </div> -->

                  <div class="flex flex-row pt-10">
                    <div class="font-bold w-200 text-base">
                      Funds Available <span class="text-xl text-mint-darker">*</span>
                    </div>
                  </div>
                  <div class="flex flex-row justify-between w-full gap-x-10 pb-5">
                    <span>Cash Available to to Withdraw</span>
                    <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                    <span class="font-bold text-gray-dark">{{this.schwabAccountModel?.balances?.totalAvailableToWithdraw
                      |
                      currency}}</span>
                  </div>
                  <div class="flex flex-row justify-between w-full gap-x-10 pb-5">
                    <span>Funds Available to Trade</span>
                    <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                    <span class="font-bold text-gray-dark">{{this.schwabAccountModel?.balances?.settledFunds |
                      currency}}</span>
                  </div>
                  <div class="flex flex-row w-full pt-25 text-sm font-bold">
                    <div class="font-bold italic text-gray-dark">
                      <span class="text-xl text-mint-darker">*</span> Schwab account values as of
                      {{schwabLastUpdatedDate | date: "mediumTime"}}
                    </div>
                  </div>
                </div>
                }

              </div>
            </div>
          </mat-tab>
          @if (this.orionAccountSleeves && this.orionAccountSleeves.length > 0) {
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="ml-10">Sleeves</span>
            </ng-template>
            <div
              class="flex flex-col w-full h-640 overflow-y-scroll overflow-x-hidden border-t border-solid border-gray-lighter bg-gradient-to-t from-gray-lighter to-gray-lightest text-sm">
              <div class="grid gap-10 p-20 overflow-auto grid-cols-1 w-full">
                @for (acct of this.orionAccountSleeves; track acct) {
                <!-- @if (acct.Detail.accountValue.holdings && acct.Detail.accountValue.holdings.length > 0) { -->

                <div class="flex flex-col flex-grow p-20 bg-no-repeat bg-cover card bg-wave-sm">
                  <div class="flex flex-row w-full font-bold text-base">
                    <div class="font-bold text-mint-darker">
                      <!-- {{account?.accountNumber}} -->
                      @if (acct.Detail.accountNumber === account?.accountNumber && acct.Detail.model === null) {
                      <span>Custodial</span>
                      } 
                      @else if (acct.Detail.accountNumber.includes('_Contribution')) {
                        <span>Contribution Cash</span>
                      }
                      @else if (acct.Detail.accountNumber.includes('_Distribution')) {
                        <span>Distribution Cash</span>
                      }
                      @else {
                      <span>{{acct.Detail.model}}</span>
                      }
                      <span class="text-xl text-mint-darker">*</span>
                    </div>
                  </div>
                  <hr class="mb-5" />
                  <div class="flex flex-row">
                    <div class="flex w-1/3 pb-5 justify-start pr-25">
                      <div class="flex flex-col w-350 pr-5">
                        <div class="flex flex-row justify-between gap-x-10 pb-5 text-base">
                          <span class="font-bold">Total Value</span>
                          <span class="flex-grow border-b border-dotted border-gray-lighter"></span>                        
                          <span class="font-bold text-mint-darker">{{(acct.Detail.summarySection.managedValue +
                            acct.Detail.summarySection.excludedValue) | currency}}</span>
                        </div>
                        @if (this.orionAccountSleeves.length > 1) {
                        <div class="flex flex-row justify-between gap-x-10 pl-5 pb-5 text-sm">
                          <span>% of Account</span>
                          <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                          <span class="font-bold text-gray-dark">{{this.orionTotalAccountValue > 0 ? (((acct.Detail.summarySection.managedValue +
                            acct.Detail.summarySection.excludedValue) / this.orionTotalAccountValue) * 100).toFixed(2) : '0'
                            }}%</span>
                        </div>
                        }
                       
                        <div class="flex flex-row justify-between gap-x-10 pl-5 pb-5 text-sm">
                          <span>Managed Value</span>
                          <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                          <span class="font-bold text-gray-dark">{{acct.Detail.summarySection.managedValue|
                            currency}}</span>
                        </div>                                                           
                        <div class="flex flex-row justify-between gap-x-10 pl-5 pb-5 text-sm">
                          <span>Managed Cash</span>
                          <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                          <span class="font-bold text-gray-dark">{{acct.Detail.summarySection.cashAvailable |
                            currency}}</span>
                        </div>
                        <div class="flex flex-row justify-between gap-x-10 pl-5 pb-5 text-sm">
                          <span>Set Aside Cash</span>
                          <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                          <span class="font-bold text-gray-dark">{{acct.Detail.summarySection.setAsideCash |
                            currency}}</span>
                        </div>                        
                      </div>
                    </div>                          
                    <!-- <div class="flex w-1/3 pb-5 justify-end pl-25">
                      <div class="flex flex-col w-350 pr-5">
                        <div class="flex flex-row justify-between gap-x-10 pb-5 text-base">
                          <span class="font-bold">Total Cash</span>
                          <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                          <span class="font-bold text-mint-darker">{{(acct.Detail.summarySection.cashReserve +
                            acct.Detail.summarySection.setAsideCash + acct.Detail.summarySection.cashAvailable) |
                            currency}}</span>
                        </div>
                        <div class="flex flex-row justify-between gap-x-10 pl-5 pb-5 text-sm">
                          <span>Available</span>
                          <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                          <span class="font-bold text-gray-dark">{{acct.Detail.summarySection.cashAvailable |
                            currency}}</span>
                        </div>
                        <div class="flex flex-row justify-between gap-x-10 pl-5 pb-5 text-sm">
                        <span>Reserve</span>
                        <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                        <span class="font-bold text-gray-dark">{{acct.Detail.summarySection.cashReserve | currency}}</span>
                      </div>
                        <div class="flex flex-row justify-between gap-x-10 pl-5 pb-5 text-sm">
                          <span>Set Aside</span>
                          <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                          <span class="font-bold text-gray-dark">{{acct.Detail.summarySection.setAsideCash |
                            currency}}</span>
                        </div>
                        <div class="flex flex-row justify-between gap-x-10 pl-5 pb-5 text-sm">
                          <span>Current Cash %</span>
                          <span class="flex-grow border-b border-dotted border-gray-lighter"></span>
                          <span class="font-bold text-gray-dark">{{ (((acct.Detail.summarySection.cashReserve +
                            acct.Detail.summarySection.setAsideCash + acct.Detail.summarySection.cashAvailable) /
                            acct.Detail.summarySection.managedValue) * 100).toFixed(2) }}%</span>
                        </div>
                      </div>
                    </div> -->
                  </div>
                  <div class="flex flex-row">
                    <div class="flex flex-col w-2/3 pb-5">
                      <div class="flex flex-col justify-between gap-x-10 pb-5 text-base">
                        <div class="flex flex-row mt-5 items-center">
                            <!-- <span class="font-bold w-200">Positions</span> -->
                            <!-- <span class="material-icons text-mint-darker dark:text-mint-darker"
                              >{{acct.ShowPositions ? 'keyboard_arrow_right' :
                            'keyboard_arrow_down'}}</span> -->
                             <button mat-button class="icon-button is-mint is-inverted is-sm"
                              [class]="acct.ShowPositions ? 'bg-gray-lighter' : ''"
                              aria-label="Show/Hide Sleeves" (click)="acct.ShowPositions=!acct.ShowPositions">
                              <span class="material-icons mi-18">{{acct.ShowPositions ? 'keyboard_arrow_down' :
                              'keyboard_arrow_right'}}</span>
                            </button>
                            <a class="flex text-xs font-bold text-mint-darker uppercase cursor-pointer pl-5"
                              (click)="acct.ShowPositions = !acct.ShowPositions">
                              <span>{{ acct.ShowPositions ? 'Hide Positions' : 'Show Positions' }}</span>
                            </a>
                        </div>                      
                        @if (acct.ShowPositions) {
                        <div class="flex flex-col flex-grow p-5 mt-5">                          
                          <div class="text-sm">
                            <table class="w-full">
                              <thead>
                                <tr class="font-semibold border-b border-solid md:p-30 border-gray-lighter">
                                  <td style="width: 40%">Security</td>
                                  <td style="width: 15%">Symbol</td>
                                  <td style="width: 15%" class="text-right">Market Value</td>
                                  <td style="width: 15%" class="text-right">Quantity</td>
                                  <td style="width: 15%" class="text-right">Percentage</td>
                                </tr>
                              </thead>
                              @if (acct.Detail.accountValue.holdings && acct.Detail.accountValue.holdings.length > 0)
                              {
                              <tbody class="custom-table-rows">
                                @for (position of acct.Detail.accountValue.holdings; track position) {
                                <tr>
                                  <td style="width: 40%">{{position.securityName}}</td>
                                  <td style="width: 15%">{{position.securitySymbol}}</td>
                                  <td style="width: 15%" class="text-right">{{position.marketValue | currency}}</td>
                                  <td style="width: 15%" class="text-right">{{position.unit.toFixed(2)}}</td>
                                  <td style="width: 15%" class="text-right">{{position.percentage.toFixed(2)}} %</td>
                                </tr>
                                }
                              </tbody>
                              }
                              @else {
                              No Positions Found
                              }
                            </table>
                          </div>
                        </div>
                        }

                      </div>
                    </div>
                  </div>
                </div>

                <!-- } -->
                }

              </div>
              <div class="m-15 flex flex-row w-full text-sm border-t border-solid border-gray-lighter">
                <div class="font-bold italic text-gray-dark">
                  <span class="text-xl text-mint-darker">*</span> Orion account values as of {{this.orionLastUpdatedDate |
                  date:
                  'medium'}}
                </div>
              </div>
            </div>
          </mat-tab>       
          }
        </mat-tab-group>
      </div>
      }
    </div>
  </div>
</section>